import React from 'react';

const AboutUs = () => {
    return (
        <section id="about" className="w-full bg-[#e3daed]">
            {/* Professional wrapper with responsive padding and max-width */}
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 max-w-7xl">
                {/* Inner content with proper vertical spacing */}
                <div className="min-h-screen flex items-center py-16 sm:py-20 md:py-24 lg:py-0">
                    <div className="w-full flex flex-col lg:flex-row lg:gap-8 xl:gap-12 2xl:gap-16 lg:h-screen">

                        {/* Left Section - Image/Visual */}
                        <div className="w-full lg:w-1/2 flex justify-center lg:items-center lg:justify-center mb-16 sm:mb-20 md:mb-24 lg:mb-0 lg:py-20 xl:py-24">
                            {/* Image container with size controls:
                                - max-w-xs (320px) → max-w-sm (384px) → max-w-md (448px) → max-w-lg (512px) → max-w-xl (576px)
                                - Or use custom values: max-w-[250px], max-w-[300px], etc.
                                - aspect-[3/4] = portrait, aspect-[2/3] = taller, aspect-[4/5] = less tall, aspect-[1/1] = square
                            */}
                            <div className="w-full max-w-sm sm:max-w-md md:max-w-lg aspect-[3/4] sm:aspect-[3/4] md:aspect-[4/5] lg:h-full lg:max-w-xl">
                                {/* Image container with aspect ratio maintained */}
                                <div className="w-full h-full overflow-hidden rounded-lg shadow-lg lg:aspect-auto">
                                    <img src="ashima.jpg" alt="" className='w-full h-full object-cover object-top lg:object-center' />
                                </div>
                            </div>

                            {/* Alternative: Natural height image (uncomment to use)
                            <div className="w-full lg:h-full lg:max-w-xl">
                                <div className="w-full overflow-hidden rounded-lg shadow-lg">
                                    <img src="ashima.jpg" alt="" className='w-full h-auto lg:h-full lg:object-cover' />
                                </div>
                            </div>
                            */}

                            {/* Alternative 2: Full width on mobile, constrained on larger screens
                            <div className="w-full sm:max-w-md md:max-w-lg aspect-[3/4] sm:aspect-[3/4] md:aspect-[4/5] lg:h-full lg:max-w-xl mb-16 sm:mb-20 md:mb-24 lg:mb-0">
                                Then remove max-width constraints from text section on mobile too
                            </div>
                            */}
                        </div>

                        {/* Right Section - Content */}
                        <div className="w-full lg:w-1/2 flex flex-col justify-center lg:justify-start lg:h-full">
                            {/* Content wrapper with proper spacing */}
                            <div className="flex flex-col justify-between h-full lg:h-full w-full max-w-sm sm:max-w-md md:max-w-lg mx-auto lg:mx-0 lg:max-w-none lg:py-20 xl:py-24" id='RightSection-Content-Parent'>
                                {/* Top Section - About Label + Heading */}
                                <div className='flex flex-col mb-12 sm:mb-16 lg:mb-0' id='About-us+Title-Parent'>
                                    {/* About Label */}
                                    <div className="font-nunito text-sm sm:text-sm lg:text-base font-light text-black mb-2 sm:mb-3 lg:mb-4 tracking-wider">
                                        ABOUT ME
                                    </div>

                                    {/* Main Heading */}
                                    <h1 className="font-cormorant font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-gray-900 leading-tight">
                                        Come as you are. We'll find rhythm in the unraveling.
                                    </h1>
                                </div>

                                {/* Bottom Section - Description Paragraphs */}
                                <div className="space-y-4 sm:space-y-5 lg:space-y-4" id='About-us-Description-Parent'>
                                    <p className="font-nunito text-base sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                                        I didn't choose therapy as a profession — it chose me, quietly, through the stories I carried, the people I met, and the deep desire to make sense of what often goes unseen or unspoken. I became a therapist because I've always been drawn to the layers beneath — the pause before the tears, the silence behind the smile, the ache in the words left unsaid.
                                    </p>

                                    <p className="font-nunito text-base sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                                        To me, therapy is not just a service — it's a relationship, a process of remembrance and becoming. It's where people come home to themselves. I hold this space with reverence: for your pain, your growth, your confusion, and your courage. My work is to walk beside you — not ahead, not behind — as you make meaning of your life, in your own language, at your own pace.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;